import { formatBool } from '@/utils/shared';
import dateFormatter from '@/services/formatter_services/date-formatter';

const OFFICIAL_HOLIDAYS_WIDGETS = Object.freeze({
  OFFICIAL_HOLIDAYS_WIDGETS: [
    {
      id: 'officialHolidays',
      moduleId: 'officialHolidays',
      path: 'officialholidays',
      type: 'TABLE',
      getData: response => response.data.data?.map(data => data.data),
      headers: [
        {
          text: 'Common.date',
          value: 'date',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Common.label',
          value: 'label'
        },
        {
          text: 'Dashboard.widgets.officialHolidays.headers.state',
          value: 'state'
        },
        {
          text: 'Dashboard.widgets.officialHolidays.headers.dateFraction',
          value: 'dateFraction'
        }
      ],
      withRouterActionLink: true
    },
    {
      id: 'officialholidaysAmount',
      path: 'officialholidays',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'officialholidays'
    }
  ],
  CALENDAR_WIDGETS: [
    {
      id: 'officialHolidayCalendars',
      moduleId: 'officialHolidayCalendars',
      path: 'officialholidaycalendars',
      type: 'TABLE',
      getData: response => response.data.data?.map(data => data.data),
      headers: [
        {
          text: 'Dashboard.widgets.officialHolidayCalendars.headers.year',
          value: 'year'
        },
        {
          text: 'Dashboard.widgets.officialHolidayCalendars.headers.isActive',
          value: 'isActive',
          presentWith: formatBool
        },
        {
          text: 'Dashboard.widgets.officialHolidayCalendars.headers.state',
          value: 'state'
        },
        {
          text: 'Dashboard.widgets.officialHolidayCalendars.headers.activatedBy',
          value: 'activatedBy'
        },
        {
          text: 'Dashboard.widgets.officialHolidayCalendars.headers.activatedAt',
          value: 'activatedAt',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        }
      ],
      withRouterActionLink: true
    }
  ],
  STATES_WIDGETS: [
    {
      id: 'states',
      moduleId: 'states',
      path: 'states',
      type: 'TABLE',
      getData: response => response.data.data?.map(data => data.data),
      headers: [
        {
          text: 'Dashboard.widgets.states.headers.iso31662Id',
          value: 'iso31662Id'
        },
        {
          text: 'Common.label',
          value: 'label'
        }
      ],
      withRouterActionLink: true
    },
    {
      id: 'statesAmount',
      path: 'states',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'states'
    }
  ]
});
export default OFFICIAL_HOLIDAYS_WIDGETS;
